/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemPreviews_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Tiles_viewer$ref: FragmentReference;
export type Tiles_viewer = {|
  +$fragmentRefs: ItemPreviews_viewer$ref,
  +$refType: Tiles_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Tiles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemPreviews_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '654b0c93667758adb3df152899f4d739';
module.exports = node;
